<!--
 * @Author: zjw
 * @Date: 2021-06-01 11:31:36
 * @LastEditTime: 2021-06-10 15:00:13
 * @FilePath: \web-app\src\components\content\myImport.vue
 * @Environment: Vue + Element
 * @Description: 导入组件
-->
<template>
    <el-upload
        class="upload"
        ref="upload"
        name="multipartFile"
        accept=".xls, .xlsx"
        :action="uploadUrl"
        :before-upload="beforeUpload"
        :on-success="uploadSuccess"
        :show-file-list="false"
    >
        <el-button size="small" type="primary" plain round>批量导入</el-button>
    </el-upload>
</template>
<script>
export default {
    name: 'myImport',
    inject: ['importType', 'initData'], //由父组件provide提供变量，然后让子组件使用inject来注入获取变量
    data() {
        return {
            uploadUrl: `/api/app/sys/${this.importType}/import`,
        }
    },
    created() {},
    methods: {
        beforeUpload(file) {
            let extension = file.name.substring(file.name.lastIndexOf('.') + 1)
            if (extension != 'xlsx') {
                this.$message({
                    message: '上传文件格式错误!',
                    type: 'warning',
                })
                return false
            }
        },
        uploadSuccess(res, file, fileList) {
            if (file.status == 'success') {
                this.initData()
                this.$message({
                    message: '导入成功!',
                    type: 'success',
                })
            } else {
                this.$message(res.message, '导入失败', {
                    message: '导入失败!',
                    type: 'error',
                })
            }
            this.$refs.upload.clearFiles()
        },
    },
}
</script>


